// @flow
import React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import Icon from 'components/Icon';
import { fonts, colors, transition, fontWeights } from '../theme';

export const StyledSelect = styled.select.attrs(
  ({ disableGreyOnNull, value }) => ({
    style:
      !disableGreyOnNull && (value === null || value === '')
        ? {
            color: colors.battleshipGrey
          }
        : null
  })
)`
  width: 100%;
  height: 45px;
  padding-left: 1em;
  padding-right: 36px;
  border: solid 1px ${colors.silver};
  color: ${colors.charcoalGrey};
  background-color: white;
  border-radius: 4px;
  appearance: none;
  font-size: 18px;
  font-family: ${fonts.sans};
  transition: all ${transition};
  &:focus {
    border-color: ${colors.waterBlue};
    box-shadow: 0 0 0 1px ${colors.waterBlue} inset;
    outline: 0;
  }
  ${props =>
    props.hasError &&
    `
    border-color: ${colors.scarlet};
    box-shadow: 0 0 0 1px ${colors.scarlet};
  `}
  &::-ms-expand {
    display: none;
  }
  option {
    color: ${colors.greyishBrown};
  }
  ${props =>
    props.small &&
    `
  height: 36px;
  padding-right: 48px;
  padding-left: 12px;
  background: transparent;
  color: ${colors.battleshipGrey};
  font-size: 16px;
  font-weight: ${fontWeights.semiBold};
  `}
`;

const SelectInput = ({
  name,
  value,
  options,
  onChange = () => undefined,
  hasError,
  small,
  ...props
}: {
  name?: string,
  value?: string,
  options: $ReadOnlyArray<{ value: ?string, label: string }>,
  onChange?: string => void,
  'data-qa-id'?: string,
  hasError?: boolean,
  small?: boolean
}) => (
  <Box position="relative">
    <StyledSelect
      name={name}
      small={small}
      value={value}
      onChange={e => {
        onChange(e.target.value);
      }}
      hasError={hasError}
      {...props}
    >
      {options.map(({ value: optionValue, label, ...optionProps }) => (
        <option key={optionValue} value={optionValue} {...optionProps}>
          {label}
        </option>
      ))}
    </StyledSelect>
    <Box
      position="absolute"
      top="50%"
      right={small ? 12 : 19}
      transform="translateY(-50%)"
      pointerEvents="none"
    >
      <Icon
        name="chevron"
        width={small ? '10px' : '15px'}
        height="9px"
        display="block"
      />
    </Box>
  </Box>
);

export default SelectInput;
